export type DocumentPreview = {
  text?: string;
  rows?: string[][];
  html?: string;
  note: string;
};
export const DOCUMENT_PREVIEW_BYTES = 8 * 1024 * 1024;
export const DOCUMENT_PREVIEW_TIMEOUT = 15_000;
export const DOCUMENT_PREVIEW_TEXT = 24_000;

export function fileExtension(name: string) {
  return name.split(".").pop()?.toLowerCase() ?? "";
}

export function textPreview(
  text: string,
  note = "Text preview",
): DocumentPreview {
  // Controls other than line breaks/tabs have no useful visible representation.
  return {
    text: text
      .replace(/[\x00-\x08\x0b\x0c\x0e-\x1f]/g, "")
      .slice(0, DOCUMENT_PREVIEW_TEXT),
    note: `${note} · beginning of file`,
  };
}
